module.exports = {
	"ugc_dob": {
		"type": "date",
		"question": "When were they born?",
		"options": {
			"globalAction": "ugc_dod",
			"yes": {
				"position": 2,
				"label": "Submit"
			},
			"skip": {
				"position": 1,
				"label": "Not Sure"
			}
		}
	},
	"ugc_dod": {
		"type": "date",
		"question": "When did they pass away?",
		"options": {
			"globalAction": "ugc_location_born",
			"yes": {
				"position": 2,
				"label": "Submit"
			},
			"skip": {
				"position": 1,
				"label": "Not Sure"
			}
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/reactModules/pages/Person/components/Questionnaire/data/dates.json
// module id = 1697
// module chunks = 0